import { QuestionAttachment } from "../Audits/question-attachment";

export class ActionResponse {
    public ActionID: number = -1;
    public Resolved: boolean = false;
    public Note: string = "";
    public ResponseDate: Date = new Date();
    public Username: string = "";
    public ActionPhotos: string[] = [];
    public ActionAttachments: QuestionAttachment[] = [];
    constructor(values: Object = {}) {
        Object.assign(this, values);
        if (values.hasOwnProperty('ActionPhotos')) {
            this.ActionPhotos = [];
            ((values as ActionResponse)['ActionPhotos'] as string[]).forEach(element => {
                this.ActionPhotos.push(element.toString());
            });
        }
        if (values.hasOwnProperty('ActionAttachments')) {
            this.ActionAttachments = [];
            ((values as ActionResponse)['ActionAttachments'] as QuestionAttachment[]).forEach(element => {
                this.ActionAttachments.push(new QuestionAttachment(element));
            });
        }
    }
}